import React, { useState, useEffect } from "react";
import { getEventsTab, getEventsTabClear } from "../../redux/events/actions";
import { useDispatch, useSelector } from "react-redux";
import { SessionKeys } from "../../utils/AppUtils";
import _ from "lodash";
import EventDetailSection from "./EventDetailSection";
import moment from "moment";

const EventDetailComponent = ({ userId, isEvent, isOther }) => {
  let dispatch = useDispatch();

  const [eventsData, setEventsData] = useState([]);
  const [registered, setRegistered] = useState(0);
  const [attended, setAttended] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [searchText, setSearchText] = useState("");
  const eventDataResponse = useSelector((state) => state.events.eventsTabData);
  const [isLoading, setIsLoading] = useState(true);

  // const [series, setSeries] = useState([]);
  // const [labels, setLabels] = useState(["Attended", "Registered"]);

  // const [colors, setColors] = useState(["#A9DBB8", "#f0a446"]);

  const getEventData = (date) => {
    dispatch(
      getEventsTab({
        module: "getEventsTabData",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          search: searchText,
          date: date
            ? moment(date).format("YYYY")
            : selectedMonth
            ? moment(selectedMonth).format("YYYY")
            : "",
          user_id: userId,
          type: isEvent ? "event" : "certification",
        },
      })
    );
  };

  const [sections, setSections] = useState([]);

  useEffect(() => {
    if (!_.isEmpty(eventDataResponse)) {
      if (eventDataResponse?.status === "success") {
        console.log("eventsdata---", eventDataResponse);
        const reportData = eventDataResponse?.payload?.payload?.list;
        let registered_data =
          eventDataResponse?.payload?.payload?.registered_count;
        let attended_data = eventDataResponse?.payload?.payload?.attended_count;
        let sections_data = [];
        let total = attended_data + registered_data;

        let per1 = (attended_data / total) * 100;
        sections_data.push({
          value: per1,
          color: "rgba(71, 196, 120, 1)",
          label: "Attended",
          number: attended_data,
        });

        let per = (registered_data / total) * 100;
        sections_data.push({
          value: per,
          color: "rgba(240, 164, 70, 1)",
          label: "Registered",
          number: registered_data,
        });
        console.log("sections-- a", sections_data);

        setSections(sections_data);
        setRegistered(registered_data > 0 ? registered_data : 0);
        setAttended(attended_data > 0 ? attended_data : 0);
        const sortedData = _.reverse(_.sortBy(reportData, "date"));
        setEventsData(sortedData);
      } else {
        setEventsData([]);
        setSections([]);
        setRegistered(0);
        setAttended(0);
      }
      setIsLoading(false);
    }
  }, [eventDataResponse]);

  useEffect(() => {
    setIsLoading(true);
    setIsStatusAsc("");
    setIsSessionNameAsc("");
    setIsDateAsc(true);
    setIsEventNameAsc("");
    setSections([]);
    setSearchText("");
    setSelectedMonth(new Date());
  }, [isEvent]);

  useEffect(() => {
    setIsLoading(true);
    getEventData("");
    return () => {
      dispatch(getEventsTabClear());
    };
  }, [selectedMonth]);

  const onSearchClicked = () => {
    setIsLoading(true);
    getEventData();
  };

  // useEffect(() => {
  //   setIsLoading(true);
  //   getEventData();
  // }, [selectedMonth]);

  const [isEventNameAsc, setIsEventNameAsc] = useState("");
  const [isSessionNameAsc, setIsSessionNameAsc] = useState("");
  const [isDateAsc, setIsDateAsc] = useState(true);
  const [isStatusAsc, setIsStatusAsc] = useState("");

  const setEventNameOrder = () => {
    if (isEventNameAsc === "") {
      setIsEventNameAsc(!isEventNameAsc);
    } else {
      setIsEventNameAsc(!isEventNameAsc);
    }
  };

  const setSessionNameOrder = () => {
    if (isSessionNameAsc === "") {
      setIsSessionNameAsc(!isSessionNameAsc);
    } else {
      setIsSessionNameAsc(!isSessionNameAsc);
    }
  };

  const setStatusOrder = () => {
    if (isStatusAsc === "") {
      setIsStatusAsc(true);
    } else {
      setIsStatusAsc(!isStatusAsc);
    }
  };

  useEffect(() => {
    if (isEventNameAsc) {
      const sortedData = _.orderBy(
        eventsData,
        [(report) => report?.event_name?.toLowerCase()],
        "asc"
      );
      setEventsData(sortedData);
    } else {
      const sortedData = _.orderBy(
        eventsData,
        [(report) => report?.event_name?.toLowerCase()],
        "desc"
      );
      setEventsData(sortedData);
    }
  }, [isEventNameAsc]);

  useEffect(() => {
    if (isSessionNameAsc) {
      const sortedData = _.orderBy(
        eventsData,
        [(report) => report?.session_name?.toLowerCase()],
        "asc"
      );
      setEventsData(sortedData);
    } else {
      const sortedData = _.orderBy(
        eventsData,
        [(report) => report?.session_name?.toLowerCase()],
        "desc"
      );
      setEventsData(sortedData);
    }
  }, [isSessionNameAsc]);

  const setDateOrder = () => {
    setIsDateAsc(!isDateAsc);
  };

  useEffect(() => {
    if (isDateAsc) {
      const sortedData = _.orderBy(eventsData, "date", "desc");
      setEventsData(sortedData);
    } else {
      const sortedData = _.orderBy(eventsData, "date", "asc");
      setEventsData(sortedData);
    }
  }, [isDateAsc]);

  useEffect(() => {
    if (isStatusAsc) {
      const sortedData = _.orderBy(
        eventsData,
        [(report) => report?.status?.toLowerCase()],
        "asc"
      );
      setEventsData(sortedData);
    } else {
      const sortedData = _.orderBy(
        eventsData,
        [(report) => report?.status?.toLowerCase()],
        "desc"
      );
      setEventsData(sortedData);
    }
  }, [isStatusAsc]);

  return (
    <>
      <EventDetailSection
        isLoading={isLoading}
        isEvent={isEvent}
        eventsData={eventsData}
        registered={registered}
        attended={attended}
        sections={sections}
        onSearchClicked={onSearchClicked}
        searchText={searchText}
        setSearchText={setSearchText}
        selectedMonth={selectedMonth}
        setSelectedMonth={setSelectedMonth}
        isSessionNameAsc={isSessionNameAsc}
        isEventNameAsc={isEventNameAsc}
        isDateAsc={isDateAsc}
        setDateOrder={setDateOrder}
        setEventNameOrder={setEventNameOrder}
        setSessionNameOrder={setSessionNameOrder}
        isStatusAsc={isStatusAsc}
        setStatusOrder={setStatusOrder}
        isOther={isOther}
      />
    </>
  );
};

export default EventDetailComponent;
